import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Dimmer, Loader } from 'semantic-ui-react';
import { useAuth } from '../../../providers/AuthenticationProvider';
import { useWeatherStation } from "../../../providers/WeatherStationProvider";
import "../WeatherStations.css";
import { AddButton } from "../../../components/AddButton/AddButton";

const WEB_PAGE = 'Weather Stations';

export const WeatherStationsList = () => {
    const { checkAuth, getUserType } = useAuth();
    const navigate = useNavigate();
    const {
        weatherStations,
        total,
        pageSize,
        setPageSize,
        pageIndex,
        setPageIndex,
        sortState,
        setSortState,
        queryWeatherStations
    } = useWeatherStation();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (checkAuth(getUserType(), WEB_PAGE)) {
            navigate('/');
        }
    }, []);

    useEffect(() => {
        setLoading(true);
        const fetchWeatherStations = async () => {
            await queryWeatherStations();
            setLoading(false);
        };
        fetchWeatherStations();
    }, [pageSize, pageIndex, sortState, queryWeatherStations]);

    const handlePageChange = (e) => {
        setPageIndex(e.page.skip / e.page.take);
        setPageSize(e.page.take);
    };

    const handleSortChange = (e) => {
        setSortState(e.sort.length ? [{ fieldName: e.sort[0].field, dir: e.sort[0].dir }] : []);
    };

    const sort = sortState.map(s => ({ field: s.fieldName, dir: s.dir }));

    const formatDate = (date) => {
        if (!date) return '--';
        return new Date(date).toLocaleString();
    };

    return (
        <div>
            <div className="pageHeader">
                <h1>Weather Stations</h1>
                <AddButton to="/weather-stations/create">Create Weather Station</AddButton>
            </div>
            <div style={{ position: 'relative' }}>
                <Dimmer active={loading} inverted>
                    <Loader />
                </Dimmer>
                <Grid
                    data={weatherStations}
                    total={total}
                    skip={pageIndex * pageSize}
                    take={pageSize}
                    pageable={true}
                    sortable={true}
                    sort={sort}
                    onPageChange={handlePageChange}
                    onSortChange={handleSortChange}
                    onRowClick={e => navigate(`/weather-stations/edit/${e.dataItem.id}`)}
                >
                    <Column field="name" title="Name" />
                    <Column field="usaf" title="USAF" width={100} />
                    <Column field="wban" title="WBAN" width={100} />
                    <Column field="icao" title="ICAO" width={100} />
                    <Column
                        field="earliestRecordDate"
                        title="Min Date"
                        cell={props => <td>{formatDate(props.dataItem.earliestRecordDate)}</td>}
                    />
                    <Column
                        field="latestRecordDate"
                        title="Max Date"
                        cell={props => <td>{formatDate(props.dataItem.latestRecordDate)}</td>}
                    />
                </Grid>
            </div>
        </div>
    );
};
